var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardDoubleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.59,18 19,16.59 14.42,12 19,7.41 17.59,6 11.59,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11,18 12.41,16.59 7.83,12 12.41,7.41 11,6 5,12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_left.d778939cbab46574921d840766081733.svg";
export { ForwardRef as ReactComponent };